import { gql } from 'react-apollo';

export const assignmentSession = gql`
  query getassignmentSession($assignmentId: Int!, $isImpersonating: Boolean!) {
    assignmentSession(
      assignmentId: $assignmentId
      isImpersonating: $isImpersonating
    ) {
      id: assignmentId
      timedSession {
        timeElapsed
        totalTime
        submissionStatus
        isTimerPaused
      }
    }
  }
`;

export const pauseTimer = gql`
  mutation pauseTimer($assignmentId: String!) {
    pauseTimer(assignmentId: $assignmentId) {
      ok
      elapsedTime
    }
  }
`;

export const resumeTimer = gql`
  mutation resumeTimer($assignmentId: String!) {
    resumeTimer(assignmentId: $assignmentId) {
      ok
    }
  }
`;

export const triggerTimerVisibility = gql`
  mutation triggerTimerVisibility(
    $assignmentId: String!
    $isTimerHidden: Boolean!
  ) {
    triggerTimerVisibility(
      assignmentId: $assignmentId
      isTimerHidden: $isTimerHidden
    ) {
      ok
      isTimerHidden
    }
  }
`;
